export const LMS_ENROLLMENTS_RESET_STATE = 'LMS_ENROLLMENTS_RESET_STATE';
export const LMS_ENROLLMENTS_CURRENT_ITEM = 'LMS_ENROLLMENTS_CURRENT_ITEM';

export const LMS_ENROLLMENTS_REQUEST_LOADING = 'LMS_ENROLLMENTS_REQUEST_LOADING';
export const LMS_ENROLLMENTS_REQUEST_SUCCESS = 'LMS_ENROLLMENTS_REQUEST_SUCCESS';
export const LMS_ENROLLMENTS_REQUEST_FAILED = 'LMS_ENROLLMENTS_REQUEST_FAILED';

export const LMS_ENROLLMENTS_CURRENT_ACTION = 'LMS_ENROLLMENTS_CURRENT_ACTION';
export const LMS_ENROLLMENTS_RESET_ACTION = 'LMS_ENROLLMENTS_RESET_ACTION';
